module.exports = __webpack_public_path__ + "img/free with this tutor_eng.f2ffebf5.png";